import { render, staticRenderFns } from "./aiNews.vue?vue&type=template&id=dbe30194&scoped=true"
import script from "./aiNews.vue?vue&type=script&setup=true&lang=js"
export * from "./aiNews.vue?vue&type=script&setup=true&lang=js"
import style0 from "./aiNews.vue?vue&type=style&index=0&id=dbe30194&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe30194",
  null
  
)

export default component.exports